var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.mobile
    ? _c(
        "div",
        [
          _c(
            "v-menu",
            {
              attrs: { "offset-y": "" },
              scopedSlots: _vm._u(
                [
                  {
                    key: "activator",
                    fn: function (ref) {
                      var on = ref.on
                      var attrs = ref.attrs
                      return [
                        _c(
                          "v-btn",
                          _vm._g(
                            _vm._b(
                              {
                                attrs: { icon: "" },
                                on: { click: _vm.onShowNotification },
                              },
                              "v-btn",
                              attrs,
                              false
                            ),
                            on
                          ),
                          [
                            _c(
                              "div",
                              { staticClass: "badge-icon" },
                              [
                                _vm.unread
                                  ? _c("div", { staticClass: "badge-num" }, [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.unread > 5 ? "5+" : _vm.unread
                                          )
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "v-icon",
                                  { style: { color: _vm.colorNotiIcon } },
                                  [_vm._v("notifications")]
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ],
                null,
                false,
                1405975388
              ),
            },
            [
              _vm._v(" "),
              _c(
                "v-list",
                { staticClass: "header-notification" },
                [
                  _vm._l(_vm.topNotifications, function (item, index) {
                    return _c("Notification", {
                      key: index,
                      attrs: { item: item, mobile: true },
                    })
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "ms-2 mt-1 cursor-pointer text-blue2",
                      on: {
                        click: function ($event) {
                          return _vm.tab(_vm.ROUTER_NAME.NOTIFICATION)
                        },
                      },
                    },
                    [_vm._v("すべてのお知らせを見る")]
                  ),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      )
    : _c(
        "v-btn",
        {
          attrs: { icon: "" },
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.tab(_vm.ROUTER_NAME.NOTIFICATION)
            },
          },
        },
        [
          _c("v-icon", { style: { color: _vm.colorNotiIcon } }, [
            _vm._v("notifications"),
          ]),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }